'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AssignRoleController = function AssignRoleController($scope, dataRetrieverService, userManagementDataService, userManagementCommonCustomRenderers, userManagementUsersService, $log) {
  $scope.customRenderers = userManagementCommonCustomRenderers;
  $scope.gridId = 'user-management-assign-role';
  $scope.noUsersSelected = true;
  var selectedUsers = [];
  dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', 'user-management-manage-users-mode').setCustomSearchCriteriaRules(userManagementUsersService.getUserSearchCriteria());
  $scope.onAssignButtonClick = function () {
    userManagementDataService.updateMultipleUsers(selectedUsers).then(function () {
      toastr.success('Roles assigned to selected users.');
      $scope.hideModal();
    })["catch"](function () {
      $log.error('AssignRoleController: onAssignButtonClick - Error: role assignments not saved');
      toastr.error('Error: role assignments not saved');
    });
  };
  $scope.$on('grid:cellValueChanged', function (ev, rowInfo, gridId) {
    if (gridId !== $scope.gridId) {
      return;
    }
    if (rowInfo.datafield === 'assignToRole') {
      selectedUsers = parseSelectedUsers(rowInfo.owner.source.loadedData, rowInfo);
    }
  });
  $scope.markUneditableRows = function (data) {
    return _.map(data, function (element) {
      element.assignToRole = element.role === $scope.newRole;
      element.editable = !element.assignToRole;
      return element;
    });
  };
  function parseSelectedUsers(loadedUsers, changedUserRow) {
    loadedUsers[changedUserRow.rowindex].assignToRole = changedUserRow.newvalue;
    var parsedUsers = _.chain(loadedUsers).filter(function (user) {
      return user.assignToRole && user.editable;
    }).map(function (assignedUser) {
      return {
        'userId': assignedUser.userId,
        'roles': [$scope.newRole],
        'isActive': assignedUser.isActive,
        'preferences': assignedUser.preferences,
        'responsibilities': assignedUser.responsibilities,
        'firstName': assignedUser.firstName,
        'lastName': assignedUser.lastName,
        'email': assignedUser.email,
        'cityCode': assignedUser.cityCode,
        'organization': assignedUser.organization,
        'isSabreEmployee': assignedUser.isSabreEmployee,
        'isSystemOwner': assignedUser.isSystemOwner
      };
    }).value();
    $scope.noUsersSelected = parsedUsers.length === 0;
    return parsedUsers;
  }
};
AssignRoleController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementDataService', 'UserManagementCommonCustomRenderers', 'UserManagementUsersService', '$log'];
module.exports = AssignRoleController;